import * as tslib_1 from "tslib";
import { OnInit } from "@angular/core";
import { ThemeOptions } from "../../../theme-options";
import { select } from "@angular-redux/store";
import { Observable } from "rxjs";
import { ActivatedRoute } from "@angular/router";
import { APP_SETTINGS } from "src/environments/environment";
import { Security } from "src/app/utils/security.util";
export class SidebarComponent {
    constructor(globals, activatedRoute) {
        this.globals = globals;
        this.activatedRoute = activatedRoute;
        this.tipoInstalacao = "";
        this.nivelUsuarioLogado = 0;
        this.podeAcessar = Security.getPodeAcessar();
        this.labelCentroCusto = APP_SETTINGS.LabelCentroCusto;
        this.activeId = "homeMenu";
        this.tipoInstalacao = APP_SETTINGS.tipoInstalacao;
    }
    toggleSidebar() {
        this.globals.toggleSidebar = !this.globals.toggleSidebar;
    }
    sidebarHover() {
        this.globals.sidebarHover = !this.globals.sidebarHover;
    }
    ngOnInit() {
        this.nivelUsuarioLogado = Security.getUser().nivel;
        setTimeout(() => {
            this.innerWidth = window.innerWidth;
            if (this.innerWidth < 1200) {
                this.globals.toggleSidebar = true;
            }
        });
        this.extraParameter =
            this.activatedRoute.snapshot.firstChild.data.extraParameter;
    }
    onResize(event) {
        this.newInnerWidth = event.target.innerWidth;
        if (this.newInnerWidth < 1200) {
            this.globals.toggleSidebar = true;
        }
        else {
            this.globals.toggleSidebar = false;
        }
    }
}
tslib_1.__decorate([
    select("config"),
    tslib_1.__metadata("design:type", Observable)
], SidebarComponent.prototype, "config$", void 0);
